// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'


import App from './App'
import router from './router'
import store from './store'

import VueResource from 'vue-resource'
import Icon from 'vue-awesome/components/Icon'
import ReadMore from 'vue-read-more';
import VmBackTop from 'vue-multiple-back-top'
import * as echarts from 'echarts'

import './assets/css/style.css'
import './assets/css/pygments-css/colorful.css';

// 导入 highlight.js 并挂载到 window
import hljs from 'highlight.js'
import 'highlight.js/styles/default.css'
window.hljs = hljs

// 导入 jQuery 并挂载到全局
import $ from 'jquery'
window.$ = window.jQuery = $

import './assets/js/libs/plantuml-encoder.min.js'

import 'vue-awesome/icons'
import * as filters from './filters' // global filters

Vue.config.productionTip = false
var vueFilter = require('vue-filter')

Vue.use(VueResource)
Vue.use(vueFilter)
Vue.use(echarts)
Vue.use(ReadMore);
Vue.component('icon', Icon)
Vue.component(VmBackTop.name, VmBackTop)

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.devtools = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted() {
    // script.js 与新版 hljs 冲突，暂时禁用
    // 代码高亮功能由 hljs 直接提供
  }
})




